export const GDPR_CONSENTS_GRID_CODE = 'customer-gdpr';
